module.exports = __webpack_public_path__ + "static/img/leftCode.cb0eae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/leftCode.png
// module id = pzVD
// module chunks = 1